import { isPhaseIn, isPhaseOut, isPreCr } from "@/utils/Lifecycle";
import {headerWithUnitTemplate} from "@/utils/column_mapping/HeaderTemplates";

const nc12Header = {
  headerName: "12nc",
  field: "nc12",
  sortable: true,
  hide: false,
  width: 120
};

const heightHeader = {
  headerName: "Height (mm)",
  field: "housing.height",
  sortable: true,
  hide: false,
  width: 100
};

const heightHeaderInch = {
  headerName: "Height (inch)",
  field: "housing.height",
  sortable: true,
  hide: false,
  width: 100
};

const widthHeader = {
  headerName: "Width (mm)",
  field: "housing.width",
  sortable: true,
  hide: false,
  width: 100
};

const widthHeaderInch = {
  headerName: "Width (inch)",
  field: "housing.width",
  sortable: true,
  hide: false,
  width: 100
};

const lengthHeader = {
  headerName: "Length (mm)",
  field: "housing.length",
  sortable: true,
  hide: false,
  width: 100
};

const lengthHeaderInch = {
  headerName: "Length (inch)",
  field: "housing.length",
  sortable: true,
  hide: false,
  width: 100
};

const LESDiameterHeader = {
  headerName: "LES diameter (mm)",
  field: "housing.dia",
  sortable: true,
  hide: false,
  width: 100,
  valueFormatter: params => {
    return params.value === 0 ? "-" : params.value;
  }
};

const LESDiameterHeaderInch = {
  headerName: "LES diameter (inch)",
  field: "housing.dia",
  sortable: true,
  hide: false,
  width: 100,
  valueFormatter: params => {
    return params.value === 0 ? "-" : params.value;
  }
};

const familyHeader = {
  headerName: "Application",
  field: "familyLevelOne",
  sortable: true,
  hide: false,
  width: 120
};

const fluxHeader = {
  headerName: "Flux",
  field: "calculationResult.luminousEfficacyOfModule",
  sortable: true,
  hide: false,
  width: 65,
  valueFormatter: params => {
    return Math.round(params.value);
  },
  headerComponentParams: {
    template: headerWithUnitTemplate("lm")
  }
};

const dataSheetHeader = {
  headerName: "Datasheet",
  field: "datasheetUrl",
  sortable: true,
  hide: false,
  cellRenderer: params => {
    return `<a href="${params.value}" target="_blank">View</a>`;
  },
  width: 80
};

const nameHeader = {
  headerName: "Module Name",
  field: "name",
  sortable: true,
  hide: false,
  cellRenderer: params => {
    let output = params.value;

    if (params.data.phaseIn && isPhaseIn(params.data.phaseIn)) {
      output += '<span class="phase-in" > [new] </span>';
    }

    if (params.data.phaseOut && isPhaseOut(params.data.phaseOut)) {
      output += '<span class="phase-out"> [obsolete] </span>';
    }

    if (params.data.phaseIn && isPreCr(params.data.phaseIn)) {
      output += '<span class="pre-cr"> [coming soon]</span> ';
    }

    if (params.data.isArchived) {
      output += '<span class="is-archived"> [archived]</span>';
    }

    return output;
  },
  width: 300
};

const countHeader = {
  headerName: "#",
  field: "amount",
  width: 60,
  sortable: true,
  hide: false
};

export {
  countHeader,
  nameHeader,
  dataSheetHeader,
  familyHeader,
  fluxHeader,
  LESDiameterHeader,
  LESDiameterHeaderInch,
  lengthHeader,
  lengthHeaderInch,
  widthHeader,
  widthHeaderInch,
  heightHeader,
  heightHeaderInch,
  nc12Header
};
